export default __webpack_public_path__ + "static/media/bayern_light.6578b42d.png";